import React from "react";
import { pathOr } from "ramda";
import styled from "styles/styled_components";

import { CategoryColors, categoryColors } from "helpers/schedule/roles";

export interface IFlagPosition {
  left: number;
  right: number;
}

interface ICategoryFlag {
  category: CategoryColors;
  position?: IFlagPosition;
  vertical?: boolean;
}

interface IStyledFlag {
  backgroundColor: string;
  position?: IFlagPosition;
  vertical: boolean;
}

const StyledFlag = styled.div<IStyledFlag>`
  background-color: ${(props) => props.backgroundColor};
  position: absolute;
  ${({ position, vertical, theme }) => {
    if (vertical) {
      return `
        left: 0;
        top 0;
        bottom: 0;
        width: ${theme.indicatorBorder};
      `;
    } else {
      const leftPercent = pathOr(0, ["left"], position);
      const rightPercent = pathOr(0, ["right"], position);
      return `
        left: ${leftPercent ? `${leftPercent}%` : "-1px"};
        right: ${rightPercent ? `${rightPercent}%` : "-1px"};
        top -${theme.indicatorBorder};
        height: ${theme.indicatorBorder};
      `;
    }
  }}
`;

export default function CategoryFlag({
  category,
  position,
  vertical = false,
}: ICategoryFlag) {
  const categoryColor = pathOr(
    categoryColors.Multiple, // default value
    [category],
    categoryColors
  );
  return (
    <StyledFlag
      backgroundColor={categoryColor}
      position={position}
      vertical={vertical}
    />
  );
}
